import { Inject, Injectable } from 'angular-ts-decorators';
import { IProductApiConfig } from 'src/Foundation/ProductApi/platform';

const baseTimeExpirationApiUrl = 'https://time.jabra.com/api/expiration';

export interface IOfferCountdownService {
  getOfferExpiration(endDate: string): ng.IHttpPromise<IOfferExpiration>;
}

export interface IOfferExpiration {
  milliseconds: number;
  expired: boolean;
}

@Injectable('offerCountdownService')
export class OfferCountdownService implements IOfferCountdownService {
  public static $inject = ['$http', 'productApiConfig'];

  constructor(
    @Inject('$http') private $http: ng.IHttpService,
    @Inject('productApiConfig') private productApiConfig: IProductApiConfig,
  ) {
  }

  public getOfferExpiration(endDate: string): ng.IHttpPromise<IOfferExpiration> {
    const url = `${baseTimeExpirationApiUrl}?date=${endDate}&marketLocale=${this.productApiConfig.language}`;
    return this.$http.post(url, null);
  }
}
